export const FEEDBACK_BASE_URL = id => `https://europe-west2-dpduk-t-sentry-${id}.cloudfunctions.net`;

const getFeedbackUrl = debug => `${FEEDBACK_BASE_URL(debug ? "d1" : "l1")}/submitfeedback`;

export const postFeedback = (params, options) => fetch(getFeedbackUrl(options && options.debug), {
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  },
  body: JSON.stringify(params)
}).then(response => {
  if (!response.ok) {
    return response.json().then(error => {
      throw error;
    });
  }

  return response.json();
});